import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
// import HeaderLinks from "components/Header/HeaderLinks.js";
// import CategorySection from "./Sections/CategorySection.js";
import DownloadApp from "./Sections/DownloadApp";

import styles from "assets/jss/material-kit-react/views/homePage.js";

const useStyles = makeStyles(styles);

export default function Components(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        brand="Votesha"
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 600,
          color: "white",
        }}
        {...rest}
      />
      <Parallax image={require("assets/img/feet_unsplash.jpeg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Votesha</h1>
                <h3 className={classes.subtitle}>
                  Poll your Friends
                </h3>
                <h3 className={classes.subtitle}>
                  Start a Conversation
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <DownloadApp />
        </div>
      </div>
      <Footer />
    </div>
  );
}
